// Import css
import '../scss/style.scss';

import BSN from 'bootstrap.native/dist/bootstrap-native-v4';
window.BSN = BSN; // Dit zou nog kleiner kunnen door alleen de modules mee te nemen die we gebruiken

import { initCollapsibles } from './util/collapsibles';
import { initCursusUrl } from './util/cursusurl';
import { lazyLoadYoutube } from './util/lazy-youtube';

import './util/faq-scroll-button';

// Initialiseer FlexMasonry als er een fotogalerij op de pagina staat.
const initFlexMasonry = async (context) => {
  if (context.querySelector('.bricklayer') !== null) {
    import('flexmasonry/dist/flexmasonry.css');
    const FlexMasonry = (await import('flexmasonry/src/flexmasonry')).default;
    FlexMasonry.init('.bricklayer');
  }
};

Drupal.behaviors.ssl_leiden = {
  attach: async (context, settings) => {
    initCollapsibles(context, settings);
    initCursusUrl(context, settings);
    lazyLoadYoutube(context, settings);
    void initFlexMasonry(context, settings);
  },
};
